import styled from 'styled-components';
import BasicButton from '../Basic/BasicButton';

const DeleteButton = styled(BasicButton)`
  background-color: var(--red);
`;

export default DeleteButton;
